<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Peticiones
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Peticiones de Clientes — Interés en Productos

    //- Diálogo: detalle de un artículo (lista de clientes que lo pidieron)
    v-dialog(v-model='dialogArticulo', max-width='750px')
      v-card
        v-card-title(style="background:#37474F;color:white;padding:12px 20px;")
          div
            div(style="font-size:18px;font-weight:bold;") {{ articuloSeleccionado.art_des || articuloSeleccionado.co_art }}
            div(style="font-size:12px;opacity:0.8;") {{ articuloSeleccionado.co_art }} · {{ clientesDelArticulo.length }} solicitud(es) · {{ totalCantidadArticulo }} uds en total
        v-card-text(style="padding:0;max-height:60vh;overflow-y:auto;")
          v-data-table(
            :headers='headersDetalle'
            :items='clientesDelArticulo'
            class='elevation-0'
            hide-actions
          )
            template(v-slot:items='{ item }')
              td {{ item.cli_des || item.co_cli }}
              td {{ item.co_cli }}
              td {{ item.ven_des || item.co_ven }}
              td(style="text-align:center;font-weight:bold;") {{ item.cantidad }}
              td {{ formatDate(item.fecha) }}
              td
                v-btn(icon, x-small, color='error', @click='eliminarPeticion(item._id)')
                  v-icon(small) delete
        //- Estado global del artículo
        v-divider
        v-card-text(style="background:#F5F5F5;")
          div(style="font-weight:600;font-size:13px;margin-bottom:10px;color:#37474F;") Estado global del artículo (visible para los clientes)
          v-layout(row wrap align-center)
            v-flex(xs12, sm5)
              v-select(
                v-model='estadoArticulo.estatus'
                :items='estatusGlobalOpciones'
                label='Estatus'
                outline
                hide-details
              )
            v-flex(xs12, sm7 style="padding-left:8px;")
              v-text-field(
                v-model='estadoArticulo.comentarioAdmin'
                label='Comentario para los clientes (ej: en camino, disponible en X días...)'
                outline
                hide-details
              )
        v-card-actions.justify-end
          v-btn(color='success', @click='guardarEstadoArticulo') Guardar estado
          v-btn(@click='dialogArticulo = false') Cerrar

    v-layout(row wrap style="padding: 16px;")

      //- Tarjetas resumen
      v-flex(xs12, sm4, md3)
        v-card(style="border-radius:10px;background:#1565C0;color:white;padding:16px;margin:6px;")
          div(style="font-size:13px;opacity:0.85;") Total Peticiones
          div(style="font-size:32px;font-weight:bold;") {{ peticiones.length }}

      v-flex(xs12, sm4, md3)
        v-card(style="border-radius:10px;background:#E65100;color:white;padding:16px;margin:6px;")
          div(style="font-size:13px;opacity:0.85;") Pendientes
          div(style="font-size:32px;font-weight:bold;") {{ peticionesPorEstatus('pendiente') }}

      v-flex(xs12, sm4, md3)
        v-card(style="border-radius:10px;background:#1565C0;color:white;padding:16px;margin:6px;")
          div(style="font-size:13px;opacity:0.85;") Vistas
          div(style="font-size:32px;font-weight:bold;") {{ peticionesPorEstatus('vista') }}

      v-flex(xs12, sm4, md3)
        v-card(style="border-radius:10px;background:#2E7D32;color:white;padding:16px;margin:6px;")
          div(style="font-size:13px;opacity:0.85;") Gestionadas
          div(style="font-size:32px;font-weight:bold;") {{ peticionesPorEstatus('gestionada') }}

      //- Tabla principal agrupada por artículo
      v-flex(xs12)
        v-card(style="border-radius:10px;margin:6px;")
          v-card-title(style="background:#37474F;color:white;border-radius:10px 10px 0 0;padding:10px 16px;")
            span Artículos Solicitados
            v-spacer
            v-text-field(
              v-model='filtroArticulo'
              label='Buscar artículo...'
              prepend-inner-icon='search'
              hide-details
              solo
              flat
              style="max-width:260px;background:rgba(255,255,255,0.15);border-radius:6px;"
            )
          v-card-text(style="padding:0;")
            v-data-table(
              :headers='headersAgrupado'
              :items='articulosAgrupados'
              :loading='loading'
              class='elevation-0'
              :rows-per-page-items='[20, 50, 100]'
              no-data-text='No hay peticiones registradas'
            )
              template(v-slot:items='{ item }')
                tr(style="cursor:pointer;" @click='abrirArticulo(item)')
                  td(style="font-weight:600;") {{ item.co_art }}
                  td {{ item.art_des }}
                  td(style="text-align:center;")
                    v-chip(color='#1565C0', dark, small) {{ item.totalCantidad }} uds
                  td(style="text-align:center;") {{ item.peticiones.length }}
                  td
                    v-chip(
                      v-for='(cnt, est) in item.porEstatus'
                      :key='est'
                      :color='colorEstatus(est)'
                      dark small
                      style="margin:2px;"
                    ) {{ est }}: {{ cnt }}
                  td {{ formatDate(item.ultimaFecha) }}
                  td
                    v-btn(icon, small, @click.stop='abrirArticulo(item)')
                      v-icon visibility
</template>

<script>
import Api from "@/services/methods";

export default {
  name: "Peticiones",
  data() {
    return {
      peticiones: [],
      loading: false,
      dialogArticulo: false,
      articuloSeleccionado: {},
      estadoArticulo: { estatus: 'pendiente', comentarioAdmin: '' },
      filtroArticulo: "",
      estatusOpciones: ["pendiente", "vista", "gestionada"],
      estatusGlobalOpciones: [
        { text: 'Pendiente', value: 'pendiente' },
        { text: 'En gestión', value: 'en_gestion' },
        { text: 'En camino', value: 'en_camino' },
        { text: 'Disponible', value: 'disponible' },
        { text: 'Cancelado', value: 'cancelado' }
      ],
      headersAgrupado: [
        { text: "Código", value: "co_art", sortable: true },
        { text: "Artículo", value: "art_des", sortable: true },
        { text: "Total Uds", value: "totalCantidad", sortable: true },
        { text: "Solicitudes", value: "totalPeticiones", sortable: true },
        { text: "Estatus", sortable: false },
        { text: "Última", value: "ultimaFecha", sortable: true },
        { text: "", sortable: false }
      ],
      headersDetalle: [
        { text: "Cliente", value: "cli_des" },
        { text: "Código", value: "co_cli" },
        { text: "Vendedor", value: "ven_des" },
        { text: "Cant.", value: "cantidad" },
        { text: "Fecha", value: "fecha" },
        { text: "", sortable: false }
      ]
    };
  },
  computed: {
    articulosAgrupados() {
      const a = this.filtroArticulo.toLowerCase();
      const grupos = {};
      for (const p of this.peticiones) {
        const key = p.co_art;
        if (!grupos[key]) {
          grupos[key] = {
            co_art: p.co_art,
            art_des: p.art_des,
            totalCantidad: 0,
            peticiones: [],
            porEstatus: {},
            ultimaFecha: p.fecha
          };
        }
        grupos[key].totalCantidad += p.cantidad || 0;
        grupos[key].peticiones.push(p);
        grupos[key].porEstatus[p.estatus] = (grupos[key].porEstatus[p.estatus] || 0) + 1;
        if (new Date(p.fecha) > new Date(grupos[key].ultimaFecha)) {
          grupos[key].ultimaFecha = p.fecha;
        }
      }
      let lista = Object.values(grupos).sort((a, b) => b.totalCantidad - a.totalCantidad);
      if (a) lista = lista.filter(g =>
        (g.art_des || '').toLowerCase().includes(a) ||
        (g.co_art || '').toLowerCase().includes(a)
      );
      return lista;
    },
    clientesDelArticulo() {
      return this.articuloSeleccionado.peticiones || [];
    },
    totalCantidadArticulo() {
      return this.clientesDelArticulo.reduce((s, p) => s + (p.cantidad || 0), 0);
    }
  },
  methods: {
    async cargarPeticiones() {
      this.loading = true;
      try {
        const res = await Api.get("peticiones");
        this.peticiones = res.data || [];
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async abrirArticulo(grupo) {
      this.articuloSeleccionado = grupo;
      this.estadoArticulo = { estatus: 'pendiente', comentarioAdmin: '' };
      this.dialogArticulo = true;
      try {
        const res = await Api.get(`peticiones/estado/${grupo.co_art}`);
        this.estadoArticulo = { estatus: res.data.estatus || 'pendiente', comentarioAdmin: res.data.comentarioAdmin || '' };
      } catch (e) { console.error(e); }
    },
    async guardarEstadoArticulo() {
      try {
        await Api.put(`peticiones/estado/${this.articuloSeleccionado.co_art}`, {
          art_des: this.articuloSeleccionado.art_des,
          estatus: this.estadoArticulo.estatus,
          comentarioAdmin: this.estadoArticulo.comentarioAdmin
        });
        this.$swal('Listo', 'Estado del artículo actualizado.', 'success');
      } catch (e) {
        console.error(e);
        this.$swal('Error', 'No se pudo guardar.', 'error');
      }
    },
    async actualizarEstatusItem(item) {
      try {
        await Api.put(`peticiones/${item._id}`, { estatus: item.estatus });
      } catch (e) {
        console.error(e);
        this.$swal('Error', 'No se pudo actualizar.', 'error');
      }
    },
    async eliminarPeticion(id) {
      const confirm = await this.$swal({
        title: '¿Eliminar petición?',
        text: 'Esta acción no se puede deshacer.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      });
      if (!confirm.value) return;
      try {
        await Api.delete(`peticiones/${id}`);
        this.dialogDetalle = false;
        await this.cargarPeticiones();
        this.$swal('Eliminado', 'Petición eliminada.', 'success');
      } catch (e) {
        console.error(e);
        this.$swal('Error', 'No se pudo eliminar.', 'error');
      }
    },
    peticionesPorEstatus(estatus) {
      return this.peticiones.filter(p => p.estatus === estatus).length;
    },
    colorEstatus(estatus) {
      if (estatus === "pendiente") return "#E65100";
      if (estatus === "vista") return "#1565C0";
      if (estatus === "gestionada") return "#2E7D32";
      return "grey";
    },
    formatDate(fecha) {
      if (!fecha) return "-";
      const d = new Date(fecha);
      return d.toLocaleDateString("es-VE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    }
  },
  mounted() {
    this.cargarPeticiones();
  }
};
</script>
